import { QueryFactory } from "../../../../Common";
export const QGetSettings = QueryFactory("GetSettings");
//# sourceMappingURL=QGetSettings.js.map